import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ icon, iconColor, title, value, subtitle, trend, trendValue }) => {
  const trendColors = {
    up: 'text-success',
    down: 'text-destructive',
    neutral: 'text-muted-foreground'
  };

  const trendIcons = {
    up: 'TrendingUp',
    down: 'TrendingDown',
    neutral: 'Minus'
  };

  return (
    <div className="bg-card rounded-xl shadow-md p-6 hover-lift transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
          <Icon name={icon} size={24} color={iconColor} strokeWidth={2} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 ${trendColors?.[trend]}`}>
            <Icon name={trendIcons?.[trend]} size={16} />
            <span className="text-sm font-semibold">{trendValue}</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-sm text-muted-foreground mb-1">{title}</p>
        <p className="text-2xl md:text-3xl font-bold text-foreground mb-1">{value}</p>
        <p className="text-xs text-muted-foreground">{subtitle}</p>
      </div>
    </div>
  );
};

export default StatsCard;
